import { Component, Input } from '@angular/core';
import { HybridAppService, constants } from '@edassist/common';
import { NavbarItem } from './navbar-item';
import { Router } from '@angular/router';

@Component({
	selector: 'ea-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
	@Input() items: Array<NavbarItem>;
	@Input() ariaLabel = constants.navbar.defaultAriaLabel;
	@Input() tabLikeAppearance: boolean = false;

	constructor(
		private readonly hybridAppService: HybridAppService,
		private readonly router: Router
	) {}

	navigateToWebUrl(url: string): void {
		this.hybridAppService.navigateToWebUrl(url);
	}

	isActivePage(url: string): boolean {
		const currentUrl = this.router.url.replace(/^\//, '');

		return currentUrl === url;
	}
}
